(() => {
  const body = document.body;
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const menuClose = document.querySelector("[data-menu-close]");

  const setMenu = (isOpen) => {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle("is-open", isOpen);
    body.classList.toggle("is-menu-open", isOpen);
  };

  menuToggle?.addEventListener("click", () => setMenu(true));
  menuClose?.addEventListener("click", () => setMenu(false));
  mobileMenu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenu(false));
  });

  document.querySelectorAll("[data-slider]").forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll(".hero-slide"));
    const dots = Array.from(slider.querySelectorAll("[data-slide-dot]"));
    let activeIndex = 0;

    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle("is-active", slideIndex === activeIndex);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle("is-active", dotIndex === activeIndex);
      });
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", () => showSlide(dotIndex));
    });

    if (slides.length > 1) {
      window.setInterval(() => showSlide(activeIndex + 1), 5600);
    }
  });

  document.querySelectorAll(".quantity-control").forEach((control) => {
    const input = control.querySelector("input");
    const minus = control.querySelector("[data-quantity-minus]");
    const plus = control.querySelector("[data-quantity-plus]");

    minus?.addEventListener("click", () => {
      const nextValue = Math.max(Number(input.value || 1) - 1, Number(input.min || 1));
      input.value = String(nextValue);
    });

    plus?.addEventListener("click", () => {
      input.value = String(Number(input.value || 1) + 1);
    });
  });

  document.querySelectorAll("[data-product-media]").forEach((button) => {
    button.addEventListener("click", () => {
      const gallery = button.closest(".main-product__gallery");
      gallery?.querySelectorAll("[data-product-media]").forEach((media) => {
        media.classList.toggle("is-active", media === button);
      });
    });
  });
})();
